/**
* @file Column component for displaying spendtime values.
* @author Heino Lenting
*/
import * as tslib_1 from "tslib";
import { ChangeDetectorRef } from '@angular/core';
import { ColumnBase } from '../column-base/column-base';
import { ColumnProvider } from '../../column-provider';
import { ComponentRegistry } from '../../../core/component-registry';
import { LocalisationService } from '../../../core/localisation.service';
import * as moment from 'moment';
/**
 * Column component for displaying a spend time value
 */
var ColumnSpendtimeComponent = /** @class */ (function (_super) {
    tslib_1.__extends(ColumnSpendtimeComponent, _super);
    /**
     * Constructs a ColumnSpendtimeComponent.
     * @param provider Provides the configuration information for the column.
     */
    function ColumnSpendtimeComponent(provider, changeDetector, localisationService) {
        var _this = _super.call(this, provider, changeDetector) || this;
        _this.localisationService = localisationService;
        _this.entity = _this.provider.entity;
        return _this;
    }
    /**
     * Register this column class for the column provider.
     */
    ColumnSpendtimeComponent.register = function () {
        ComponentRegistry.register('column', 'spendtime', ColumnSpendtimeComponent);
    };
    Object.defineProperty(ColumnSpendtimeComponent.prototype, "duration", {
        /**
         * Create human-readable presentation of the duraction
         */
        get: function () {
            // Todo: check if this really works (when there is data)
            return moment.duration(this.entity['Effort']);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ColumnSpendtimeComponent.prototype, "travelTime", {
        /**
         * Create human-readable presentation of the duraction
         */
        get: function () {
            // Todo: check if this really works (when there is data)
            return moment.duration(this.entity['TravelTime']);
        },
        enumerable: true,
        configurable: true
    });
    return ColumnSpendtimeComponent;
}(ColumnBase));
export { ColumnSpendtimeComponent };
